import { AssistFeatures } from "@/enums/assist-features";
import { FeatureActivateToggle } from "@/components/feature-activate-toggle";

export const RescuedAppointmentsFeatureSettingsSection = (): JSX.Element => {
  return (
    <div className="flex flex-col gap-2">
      <p
        className="font-medium text-sm text-neutral-600"
        data-testid="rescued-appointments-feature-settings-title"
      >
        Recuperação de Agendamentos
      </p>

      <div
        className="flex flex-col gap-2"
        data-testid="rescued-appointments-feature-settings-items"
      >
        <FeatureActivateToggle
          title="Recuperação de contatos"
          description="Envia mensagens automáticas para pacientes que não finalizaram o agendamento."
          featureId={AssistFeatures.RescueLeftScheduling}
        />
        <FeatureActivateToggle
          title="Recuperação de cancelamentos"
          description="Envia mensagens para incentivar o reagendamento de consultas que foram canceladas."
          featureId={AssistFeatures.RescueCancelAppointment}
        />
        <FeatureActivateToggle
          title="Recuperação de faltas"
          description="Envia mensagens para retomar pacientes que não compareceram à consulta."
          featureId={AssistFeatures.RescueNoShowAppointment}
        />
      </div>
    </div>
  );
};
